import styled from 'styled-components'

export const Track = styled.div`
  width: 100%;
  height: ${({ $height }) => $height}px;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  background-color: ${({ $bgColor }) => $bgColor || 'var(--vo-cloud)'};
  overflow: hidden;
`

export const Fill = styled.div`
  height: 100%;
  width: ${({ $value }) => $value}%;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  background-color: ${({ $color }) => $color || 'var(--color-brand)'};
  transition: width 0.3s ease;
`
